import { useEffect, useState } from 'react';
import './App.css';
import brandLogo from './assets/images/ata_code_house_logo(white).png';
import { projectShowcase } from './data/siteContent';
import HomePage from './components/HomePage';
import ProjectsPage from './components/ProjectsPage';
import ShoppingDemoPage from './components/ShoppingDemoPage';
import TopBar from './components/TopBar';

function App() {
  const [route, setRoute] = useState(() => getRouteFromHash(window.location.hash));
  const page = route.page;
  const activeTab =
    route.section === 'contact' ? 'contact' : page === 'shopping-demo' ? 'projects' : page;

  useEffect(() => {
    const syncRoute = () => setRoute(getRouteFromHash(window.location.hash));
    window.addEventListener('hashchange', syncRoute);

    if (!window.location.hash) {
      window.history.replaceState(null, '', '#home');
    }

    return () => window.removeEventListener('hashchange', syncRoute);
  }, []);

  useEffect(() => {
    if (route.section !== 'contact' || page !== 'home') {
      return;
    }

    window.requestAnimationFrame(() => {
      const contactSection = document.getElementById('contact');
      contactSection?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }, [page, route.section]);

  const navigateToHash = (hash) => {
    if (window.location.hash === hash) {
      setRoute(getRouteFromHash(hash));

      if (hash === '#home' || hash === '#projects' || hash === '#shopping-demo') {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }

      if (hash === '#contact') {
        const contactSection = document.getElementById('contact');
        contactSection?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      return;
    }

    window.location.hash = hash;
  };

  const openProjectsPage = () => {
    navigateToHash('#projects');
  };

  const openShoppingDemoPage = () => {
    navigateToHash('#shopping-demo');
  };

  const openHomePage = () => {
    navigateToHash('#home');
  };

  const openContactPage = () => {
    navigateToHash('#contact');
  };

  if (page === 'shopping-demo') {
    return <ShoppingDemoPage onBack={openProjectsPage} />;
  }

  return (
    <div className="app-shell">
      <div className="backdrop backdrop-one" />
      <div className="backdrop backdrop-two" />
      <div className="backdrop backdrop-three" />

      <TopBar
        activeTab={activeTab}
        brandLogo={brandLogo}
        onOpenContact={openContactPage}
        onOpenHome={openHomePage}
        onOpenProjects={openProjectsPage}
      />

      <main>
        {page === 'projects' ? (
          <ProjectsPage
            brandLogo={brandLogo}
            onProjectSelect={openShoppingDemoPage}
            projects={projectShowcase}
            openHomePage={openHomePage}
          />
        ) : (
          <HomePage brandLogo={brandLogo} onOpenProjects={openProjectsPage} />
        )}
      </main>
    </div>
  );
}

function getRouteFromHash(hash) {
  if (hash === '#shopping-demo') {
    return { page: 'shopping-demo', section: null };
  }

  if (hash === '#projects') {
    return { page: 'projects', section: null };
  }

  if (hash === '#contact') {
    return { page: 'home', section: 'contact' };
  }

  return { page: 'home', section: 'home' };
}

export default App;
